<template>
  <div class="flex w-full items-center absolute top-0 d-theme-dark-bg py-3">
    <vs-input
      icon-pack="feather"
      icon="icon-search"
      placeholder="Search"
      v-model="query"
      class="w-full is-label-placeholder m-0 "
    />
    <div class="flex items-center cursor-pointer" @click="toggleSearch(false)">
      <feather-icon icon="XIcon" class="ml-3"></feather-icon>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      query: ""
    };
  },

  computed: {
    ...mapState({
      search: state => state.globalApp.search
    })
  },
  watch: {
    query(text) {
      this.$store.dispatch("globalApp/setQuerySearch", text);
    }
  },
  methods: {
    toggleSearch(bol) {
      this.$store.dispatch("globalApp/toggleSearch", bol);
      this.$store.dispatch("globalApp/setQuerySearch", "");
    }
  }
};
</script>
